<template>
  <div class="share-app-container">
    <div class="poster-wrap" :class="{ isShow: bindShow && shareUrl }">
      <PosterComponent :shareConfig="shareConfig" @getImage="val => imageUrl = val" />
    </div>
    <div id="shareapp">
      <van-modal-sheet get-container="#shareapp" v-model="bindShow" title="分享到" size="212">
        <div class="share-app">
          <div class="share-wrap">
            <template v-for="(item, index) in list">
              <div class="share-item" :key="index" @click="handleClick(item)">
                <div>
                  <KaerImage :src="item.src" />
                </div>
                <p>{{ item.name }}</p>
              </div>
            </template>
          </div>
          <div class="cancel" @click="bindShow=false">取消</div>
        </div>
      </van-modal-sheet>
    </div>
  </div>
</template>

<script>
import ModalSheet from '@zyf2e/capui-mobile/lib/modal-sheet';
import '@zyf2e/capui-mobile/lib/modal-sheet/style';
import KaerImage from '@/components/image';
import PosterComponent from './poster';
import bindShow from '@/mixins/bindShow';
import { mapState } from 'vuex';
import { miniProgramId } from '@/config';

export default {
  props: {
    shareConfig: Object
  },
  components: {
    VanModalSheet: ModalSheet,
    KaerImage,
    PosterComponent
  },
  mixins: [
    bindShow
  ],
  data() {
    return {
      list: [
        { name: '微信', src: require('@/assets/share/wechat.png'), value: 'wechat' },
        { name: '朋友圈', src: require('@/assets/share/moments.png'), value: 'moments' },
        { name: '保存图片', src: require('@/assets/share/img.png'), value: 'img' }
      ],
      imageUrl: ''
    };
  },
  computed: {
    ...mapState({
      headerConfig: state => state.share.pageData.headerConfig,
      shareUrl: state => state.share.shareUrl
    })
  },
  methods: {
    handleClick(item) {
      if (!this.imageUrl) return this.$toast('二维码生成中，请稍候');
      const {
        title,
        imageUrl = 'http://static.91jkys.com/activity/img/d3a997de75364ca1a5d81ad9065d5567.png',
        content
      } = this.shareConfig;
      const link = this.shareUrl
      const shareData = {
        title,
        imageUrl,
        sub: content,
        link
      };
      if (item.value === 'wechat') {
        if (this.headerConfig?.shareConfig?.shareMiniPrograme) {
          shareData.miniprogram = {
            userName: miniProgramId,
            path: `pages/common/webview?url=${encodeURIComponent(link)}`,
            title,
            imageUrl,
            webPageUrl: link,
            desc: content
          };
        }
        Sailer.WXShareFriends(shareData, this.shareSuccess('wechat'), this.shareFail);
      } else if (item.value === 'moments') {
        Sailer.WXShareMoments(shareData, this.shareSuccess('WeChatMoments'), this.shareFail);
      } else if (item.value === 'img') {
        Sailer.saveImage(this.imageUrl.replace('data:image/png;base64,', ''), this.saveSuccess('save'), this.saveFail);
      }
      this.bindShow = false;
    },
    shareSuccess(method) {
      this.uploadData(this.$teleCodes.sharepopMethod, 'event', { method, link: this.shareUrl });
      this.$toast('分享成功');
    },
    shareFail() {
      // app 提示
      // this.$toast('分享失败')
    },
    saveSuccess(method) {
      this.uploadData(this.$teleCodes.sharepopMethod, 'event', { method, link: this.shareUrl });
      this.$toast('保存成功');
    },
    saveFail() {
      this.$toast('保存失败');
    }
  }
};
</script>

<style lang="less" scoped>
.poster-wrap {
  position: fixed;
  z-index: 3000;
  width: 225px;
  height: 400px;
  left: 50%;
  bottom: 9999px;
  transform: translateX(-50%) translateZ(3000px);

  &.isShow {
    bottom: 193Px;
  }
}

.share-app {
  height: 100%;
  background: #F5F5F5;
  display: flex;
  flex-direction: column;
  align-content: space-between;

  .share-wrap {
    background: #FFFFFF;
    display: flex;
    padding: 20px;
    height: 108px;

    .share-item {
      text-align: center;

      &:not(:first-child) {
        margin-left: 32px;
      }

      & > div {
        width: 48px;
        height: 48px;
      }

      & > p {
        margin-top: 8px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8C8C8C;
        line-height: 12px;
      }
    }
  }

  .cancel {
    height: 48px;
    line-height: 48px;
    background: #FFFFFF;
    flex-shrink: 0;
    flex-grow: 0;
    margin-top: 8px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
  }
}

/deep/ .van-modal-sheet__header-title {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #595959;
  z-index: 1;
  transform: translateZ(1px);
}

/deep/ .van-modal-sheet__content {
  z-index: 2;
  overflow-y: visible;
}
</style>

<style lang="less">
.van-popup {
  overflow-y: visible;
}
</style>
